/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_Section_DealsInputs */

const cs_nav_section_deals = /** @type {(inputs: Nav_Section_DealsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Obchody`)
};

const en_nav_section_deals = /** @type {(inputs: Nav_Section_DealsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deals`)
};

/**
* | output |
* | --- |
* | "Deals" |
*
* @param {Nav_Section_DealsInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const nav_section_deals = /** @type {((inputs?: Nav_Section_DealsInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_Section_DealsInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_nav_section_deals(inputs)
	return cs_nav_section_deals(inputs)
});